<template>
  <v-row>
    <loading v-if="vLoading" />
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col cols="12">
      <b-card class="shadow p-3 mb-5 bg-white rounded">
        <template v-slot:header>
          <v-row class="mt-2">
            <h4>بازه زمانی گزارش:</h4>
          </v-row>
          <v-row>
            <v-col cols="4">
              <b-form-group label="از تاریخ">
                <date-picker
                  v-model="reportFrom"
                  :editable="true"
                ></date-picker>
              </b-form-group>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="4">
              <b-form-group label="تا تاریخ">
                <date-picker v-model="reportTo" :editable="true"></date-picker>
              </b-form-group>
            </v-col>
            <v-col cols="3"
              ><b-btn
                :disabled="
                  !reportFrom ||
                  !reportTo ||
                  !reportType ||
                  !selectedEmployees.length
                "
                @click="getReport()"
                class="btn btn-dark my-2"
              >
                جستجو
              </b-btn></v-col
            >
          </v-row>
          <v-row class="mt-2">
            <v-col cols="9" v-if="role == 'Manager'">
              <v-row>
                <h5>لیست کاربران فعال</h5>
              </v-row>
              <v-row>
                <v-col>
                  <b-form-checkbox
                    v-for="employee in employees.filter(
                      (x) => x.status == 'active'
                    )"
                    :key="employee.id"
                    v-model="employee.selected"
                    @change="syncSelectedEmployees()"
                    class="mx-5"
                    stacked
                  >
                    {{ employee.name }} {{ employee.lastName }} (نقش:
                    {{
                      roles.filter((x) => x.value == employee.role)[0].text
                    }})</b-form-checkbox
                  >
                </v-col>
              </v-row>
              <v-row>
                <h5>لیست کاربران غیرفعال</h5>
              </v-row>
              <v-row>
                <v-col>
                  <b-form-checkbox
                    v-for="employee in employees.filter(
                      (x) => x.status == 'deactive'
                    )"
                    :key="employee.id"
                    v-model="employee.selected"
                    @change="syncSelectedEmployees()"
                    class="mx-5"
                    stacked
                  >
                    {{ employee.name }} {{ employee.lastName }} (نقش:
                    {{
                      roles.filter((x) => x.value == employee.role)[0].text
                    }})</b-form-checkbox
                  >
                </v-col>
              </v-row>
              <hr />
              <v-switch
                v-model="removeHolidays"
                label="روزهای تعطیل را حذف کن"
              ></v-switch>
            </v-col>
            <v-col cols="9" v-if="role == 'salesManager'">
              <v-row>
                <h5>لیست کاربران بازرگانی</h5>
              </v-row>
              <v-row>
                <v-col>
                  <b-form-checkbox
                    v-for="employee in employees.filter(
                      (x) =>
                        x.status == 'active' &&
                        x.username != 'testShop' &&
                        (x.role == 'trade' ||
                          x.role == 'tradeIntern' ||
                          x.role == 'salesManager' ||
                          x.role == 'tradeHead')
                    )"
                    :key="employee.id"
                    v-model="employee.selected"
                    @change="syncSelectedEmployees()"
                    class="mx-5"
                    stacked
                  >
                    {{ employee.name }} {{ employee.lastName }} (نقش:
                    {{ roles.filter((x) => x.value == employee.role)[0].text }}
                    )</b-form-checkbox
                  >
                </v-col>
              </v-row>
              <hr />
              <v-switch
                v-model="removeHolidays"
                label="روزهای تعطیل را حذف کن"
              ></v-switch>
            </v-col>
            <v-col cols="3">
              <v-row class="mt-2">
                <h4>انتخاب نوع گزارش:</h4>
              </v-row>
              <v-row>
                <v-radio-group v-model="reportType">
                  <v-radio
                    v-for="(item, index) in reportTypes"
                    :key="index"
                    :label="item.value"
                    :value="item.key"
                  ></v-radio>
                </v-radio-group>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <b-btn
              :disabled="
                !reportFrom ||
                !reportTo ||
                !reportType ||
                !selectedEmployees.length
              "
              @click="getReport()"
              class="btn btn-dark my-2"
            >
              جستجو
            </b-btn>
          </v-row>
        </template>
        <line-chart
          v-if="renderChart"
          :chartdata="reportData"
          :options="reportOptions"
        >
        </line-chart>
        <hr />
        <b-table
          v-if="renderChart"
          responsive
          show-empty
          :items="summaryData"
          :fields="summaryFields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>
      </b-card>
    </v-col>
  </v-row>
</template>
<script>
import Axios from "axios";
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import LineChart from "/src/components/charts/LineExample.vue";

export default {
  data() {
    return {
      guide: false,
      role: "",
      reportFrom: "",
      reportTo: "",
      employees: [],

      roles: [
        { value: "Manager", text: "مدیر", selected: false },
        { value: "ceo", text: "مدیرعامل", selected: false },
        { value: "secretary", text: "منشی" },
        { value: "secretaryStatus", text: "منشی*" },
        { value: "trade", text: "کارشناس بازرگانی", selected: false },
        { value: "tradeIntern", text: "کارآموز بازرگانی", selected: false },
        { value: "tradeHead", text: "کارشناس فنی", selected: false },
        { value: "queryOrganizer", text: "بازرس سفارشات", selected: false },
        { value: "accountant", text: "حسابدار", selected: false },
        { value: "salesManager", text: "مدیر فروش", selected: false },
        { value: "factory", text: "مدیر کارخانه", selected: false },
        {
          value: "factoryTechnical",
          text: "مسئول فنی کارخانه",
          selected: false,
        },
        { value: "qa", text: "QA & DCC", selected: false },
        { value: "qc", text: "مدیر کنترل کیفیت و آزمایشگاه", selected: false },
        { value: "qcAgent", text: "کنترل کیفی", selected: false },
        { value: "qcDocument", text: "سرتیفیکیت", selected: false },
        { value: "factoryPacking", text: "مسئول پکینگ", selected: false },
        { value: "production", text: "مدیر خط تولید", selected: false },
        { value: "delivery", text: "دلیوری", selected: false },
        {
          value: "coldForgingSupervisor",
          text: "سرپرست فورج سرد",
          selected: false,
        },
        { value: "cuttingNutSupervisor", text: "مهره‌تراش", selected: false },
        { value: "coatingSupervisor", text: "داک و پوشش", selected: false },
        {
          value: "threadingSupervisor",
          text: "سرپرست رزوه زنی",
          selected: false,
        },
        {
          value: "machiningSupervisor",
          text: "سرپرست ماشین کاری و فرزکاری",
          selected: false,
        },
        { value: "cncSupervisor", text: "سرپرست CNC" },
        {
          value: "knittingSupervisor",
          text: "سرپرست قلاویز زنی و مهره تراشی",
          selected: false,
        },
        { value: "weldingSupervisor", text: "سرپرست جوشکاری", selected: false },
        {
          value: "heatTreatmentSupervisor",
          text: "سرپرست عملیات حرارتی و سیاه کاری",
          selected: false,
        },
        {
          value: "hotForgingSupervisor",
          text: "سرپرست فورج گرم",
          selected: false,
        },
        {
          value: "dichromateSupervisor",
          text: "سرپرست داکرومات",
          selected: false,
        },
        { value: "cuttingSupervisor", text: "سرپرست برشکاری", selected: false },
        { value: "factoryGeneral", text: "کارمند کارخانه", selected: false },
        { value: "warehouse", text: "مسئول کل انبار", selected: false },
        {
          value: "productsWarehouse",
          text: "مسئول انبار محصولات",
          selected: false,
        },
        {
          value: "materialsWarehouse",
          text: "مسئول انبار مواد اولیه",
          selected: false,
        },
        {
          value: "toolsWarehouse",
          text: "مسئول انبار ملزومات",
          selected: false,
        },
        { value: "shop", text: "مسئول فروشگاه", selected: false },
      ],

      selectedEmployees: [],
      selectedRoles: [],
      removeHolidays: false,
      reportTypes: [
        { key: "startTime", value: "ساعت آغاز کار روزانه" },
        { key: "endTime", value: "ساعت پایان کار روزانه" },
        { key: "duration", value: "مدت زمان فعالیت روزانه" },
        { key: "new", value: "تعداد ثبت  درخواست جدید (منشی)" },
        { key: "draft", value: "تعداد ثبت پیش‌نویس" },
        { key: "getInfo", value: "تعداد مشاهده استعلام مشتری" },
        { key: "submit", value: "تعداد ارسال پرونده به مرحله بعد" },
        { key: "all", value: "تعداد خام کل فعالیت‌ها" },
        { key: "totalPoints", value: "امتیاز عملکرد مفید" },
      ],
      reportType: "",
      renderChart: false,
      reportData: {},
      reportOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "درصد استعلام‌های تایید شده",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.fetchMonthData,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "تعداد استعلام در هر ماه",
                fontFamily: "iransans",
              },
              ticks: {
                min: 0,
                fontFamily: "iransans",
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      summaryData: [],
      summaryFields: [
        { key: "name", label: "نام" },
        { key: "total", label: "تعداد کل فعالیت" },
        { key: "average", label: "میانگین فعالیت" },
      ],
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    LineChart,
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    getInfo() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/users/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.employees = res.data;
          this.employees.forEach((person) => {
            try {
              person.roleName = this.roles.filter(
                (x) => x.value == person.role
              )[0].text;
            } catch (error) {
              person.roleName = "-";
            }

            try {
              person.statusName = this.statuses.filter(
                (x) => x.value == person.status
              )[0].text;
            } catch (error) {
              person.statusName = "-";
            }
            this.vLoading = false;
          });
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.vLoading = false;
        });
    },
    syncSelectedEmployees(role) {
      this.selectedEmployees = this.employees
        .filter((x) => x.selected)
        .map((x) => x.id);
    },
    syncSelectedRole(role) {
      if (role.selected) {
        this.selectedEmployees = this.employees
          .filter((x) => x.role == role.value)
          .filter((x) => (x.selected = true));
      } else {
        this.selectedEmployees = this.employees
          .filter((x) => x.role == role.value)
          .filter((x) => (x.selected = false));
      }
    },
    getReport() {
      this.vLoading = true;
      this.renderChart = false;
      this.reportOptions.title.text = this.reportTypes.filter(
        (x) => x.key == this.reportType
      )[0].value;
      Axios.post(
        this.baseUrl + "/ppkpms/office/reports/activities",
        {
          startDate: this.reportFrom,
          endDate: this.reportTo,
          activityType: this.reportType,
          userIds: this.selectedEmployees,
          removeHolidays: this.removeHolidays,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.reportData = res.data.reportData;
          // this.reportData = res.data;
          this.summaryData = res.data.summaryData;
          this.vLoading = false;
          this.renderChart = true;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.vLoading = false;
        });
    },
  },
  mounted() {
    this.reportTo = moment(new Date()).format("jYYYY/jMM/jDD");
    this.reportFrom = moment(new Date())
      .subtract(7, "d")
      .format("jYYYY/jMM/jDD");
    this.getInfo();
    this.role = localStorage.getItem("role");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.app-body {
  overflow-x: unset !important;
}
</style>
